import { render, staticRenderFns } from "./Rm.vue?vue&type=template&id=b1a6c314"
import script from "./Rm.vue?vue&type=script&lang=js"
export * from "./Rm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports